import { render, staticRenderFns } from "./DocCommon.vue?vue&type=template&id=14a7d38f&scoped=true"
import script from "./DocCommon.vue?vue&type=script&lang=js"
export * from "./DocCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a7d38f",
  null
  
)

export default component.exports